import React from "react";
import NavTop from "../../component/NavTop";

const sectionTitle = {
  fontSize: "1rem",
  fontWeight: 600,
  marginTop: "1.75rem",
  marginBottom: "0.5rem",
  color: "#222",
};

const bodyText = {
  lineHeight: 1.65,
  color: "#555",
};

const About = () => {
  return (
    <>
      <NavTop title="Tentang Cashflow" />
      <div className="main-padding">
        <div style={{ maxWidth: "640px", margin: "0 auto" }}>
          <p
            style={{
              fontSize: "1.05rem",
              lineHeight: 1.65,
              color: "#333",
              marginBottom: 0,
            }}
          >
            Cashflow membantumu paham ke mana uangmu pergi—tanpa spreadsheet,
            tanpa template kaku.
          </p>

          <h2 style={sectionTitle}>Untuk kamu yang…</h2>
          <ul
            style={{
              paddingLeft: "1.2rem",
              lineHeight: 1.7,
              color: "#555",
              marginBottom: 0,
            }}
          >
            <li>
              Bingung kenapa saldo bulan ini turun padahal merasa tidak boros.
            </li>
            <li>Mau pisahkan keuangan pribadi dari usaha sampingan.</li>
            <li>Catat di notes HP lalu tidak pernah dibuka lagi.</li>
          </ul>

          <h2 style={sectionTitle}>Cara kerjanya</h2>
          <p style={bodyText}>
            Tiap pemasukan dan pengeluaran masuk ke{" "}
            <strong>wallet</strong>—rekening bank, dompet usaha, kas tunai,
            atau apa pun yang cocok dengan hidupmu. Tambahkan{" "}
            <strong>tag</strong> seperti "makan", "transport", atau "gaji"
            supaya pola pengeluaran terlihat seiring waktu. Selesai.
          </p>

          <h2 style={sectionTitle}>Kenapa Cashflow ada</h2>
          <p style={bodyText}>
            Saya membuat Cashflow karena saya juga butuh. Tool lain entah
            terlalu kompleks, entah terlalu mahal untuk fitur yang sebenarnya
            sederhana. Pemakaian dasar gratis—upgrade hanya kalau memang
            fiturnya berguna untukmu.
          </p>

          <h2 style={sectionTitle}>Ada masukan?</h2>
          <p style={bodyText}>
            Bug yang mengganggu, fitur yang kamu pengen, atau cerita keuangan
            yang ingin dibagi? Saya selalu balas pesan di{" "}
            <a
              href="https://wa.me/6285776556212"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "var(--primary)", fontWeight: 600 }}
            >
              WhatsApp
            </a>
            .
          </p>

          <p
            style={{
              marginTop: "2.5rem",
              paddingTop: "1.5rem",
              borderTop: "1px solid #eee",
              fontStyle: "italic",
              color: "#888",
              textAlign: "center",
            }}
          >
            Terima kasih sudah memilih Cashflow.
          </p>
        </div>
      </div>
    </>
  );
};

export default About;
